import { Box } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';

import ViewTag from '@/pages/ChargingPile/components/groupTags/ViewTag';
import type { ChargingPileGroup } from '@/types/database/chargingPile/chargingPileGroup';
import type { MqttGroupData } from '@/types/database/chargingPile/chargingPileMqttData';

import CircuitTag from '../../../../../components/groupTags/CircuitTag';
import { MqttContext } from '../../../MqttContextProvider';
import { GroupContext } from '../../../PileCtxProvider';
import { PileGroupName } from '../../../UI/UI';
import { Container, Info } from './styles';

const TypeTag: React.FC<{ type: 'circuit' | 'view' }> = ({ type }) => {
  if (type === 'circuit') {
    return <CircuitTag />;
  }
  return <ViewTag />;
};

const GroupMenuCell: React.FC<{ group: ChargingPileGroup }> = ({ group }) => {
  const [groupData, setGroupData] = useState<MqttGroupData>();
  const { setCurrentGroup, currentGroup } = useContext(GroupContext);
  const { mqttData } = useContext(MqttContext);

  const handleClick = () => {
    setCurrentGroup(group);
  };

  useEffect(() => {
    if (mqttData) {
      const newData = mqttData?.groups?.[`${group.name}-${group._id}`];
      if (newData) {
        setGroupData(newData);
      }
    }
  }, [group, mqttData]);

  return (
    <>
      <Container chosen={group._id === currentGroup?._id} onClick={handleClick}>
        <Info>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              alignItems: 'center',
              gap: '0.5rem',
              height: 'fit-content',
            }}
          >
            <PileGroupName sx={{ fontWeight: 'bold' }}>
              {group.name}
            </PileGroupName>
            <TypeTag type={group.type} />
          </Box>
          <Box
            sx={{
              width: '100%',
              display: 'grid',
              gridTemplateColumns: '1fr 1fr',
              gap: '0.5rem',
              '& > p': {
                margin: 0,
              },
            }}
          >
            <p>{`充電中：${
              typeof groupData?.pileStatus?.charging === 'number'
                ? groupData?.pileStatus?.charging
                : '無資料'
            }`}</p>
            <p>{`待機中：${
              typeof groupData?.pileStatus?.standby === 'number'
                ? groupData?.pileStatus?.standby
                : '無資料'
            }`}</p>
            <p>{`排隊中：${
              typeof groupData?.pileStatus?.waiting === 'number'
                ? groupData?.pileStatus?.waiting
                : '無資料'
            }`}</p>
            <p>{`無訊號：${
              typeof groupData?.pileStatus?.noSignal === 'number'
                ? groupData?.pileStatus?.noSignal
                : '無資料'
            }`}</p>
          </Box>
        </Info>
      </Container>
    </>
  );
};

export default GroupMenuCell;
